<template>
  <link-button class="text-start p-0" @click="onClick">
    <slot />
  </link-button>
</template>

<script>
import ajax from '../helpers/ajax'
import LinkButton from '../components/buttons/link-button'
import { mapState } from 'vuex'

export default {
  components: { LinkButton },

  props: {
    returnToPath: {
      type: String,
      required: true
    }
  },

  emits: ['click'],

  computed: {
    ...mapState(['notMeLink'])
  },

  methods: {
    onClick() {
      this.$emit('click')
      ajax[this.notMeLink.method]({
        url: this.notMeLink.url,
        successHandler: () => {
          window.top.location = this.returnToPath
        }
      })
    }
  }
}
</script>
